import { render } from "./SearchCourse.vue?vue&type=template&id=537557c6"
import script from "./SearchCourse.vue?vue&type=script&lang=js"
export * from "./SearchCourse.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__